import { AppConfigModel } from "../abstract/app-config.model";

export class AllocationType extends AppConfigModel {

    static override CLASS_NAME: string = 'AllocationType';
}
